if ( document.getElementById( 'card-element' ) ) {
    const stripe = Stripe( 'pk_live_mYnPpJb1sy7417iy0PffNMWM00XNyIat0v' );

// Create an instance of Elements.
    const elements = stripe.elements();

// Create an instance of the card Element.
    const cardNumberElement = elements.create( 'cardNumber');
    const cardExpiry = elements.create( 'cardExpiry' );
    const cardCvc = elements.create( 'cardCvc' );

// Add an instance of the card Element into the `card-element` <div>.
    cardNumberElement.mount( '#card-element' );
    cardExpiry.mount( '#card-expiry' );
    cardCvc.mount( '#card-cvc' );

    const cardholderName = document.querySelector( '[name="name"]' );
    const email = document.querySelector( '[name="email"]' );
    const address = document.querySelector( '[name="address"]' );
    const city = document.querySelector( '[name="city"]' );
    const postcode = document.querySelector( '[name="postcode"]' );
    const cardButton = document.getElementById( 'card-button' );
    const paymentMethodID = document.querySelector( '[name="paymentMethodID"]' );
    const form = document.querySelector( 'form' );

    cardButton.addEventListener( 'click', async ( ev ) => {
        if(!form.reportValidity()) {
            form.reportValidity()
            return;
        }

        const { paymentMethod, error } =
            await stripe.createPaymentMethod( 'card', cardNumberElement, {
                billing_details: {
                    name: cardholderName.value,
                    email: email.value,
                    address: {
                        line1: address.value,
                        postal_code: postcode.value,
                        city: city.value,
                        country: 'GB'
                    }
                }
            } );
        if ( error ) {
            console.log( error );
        } else {
            paymentMethodID.value = paymentMethod.id;


            form.submit();
        }
    } );
}
